<template lang="pug">
  v-dialog(max-width='500px')
    template(v-slot:activator='{ on }')
      v-btn( v-on='on' icon)
        v-icon( icon ) fab fa-whatsapp
    v-card 
      v-card-title whatsapp
      v-card-text {{proveedores}} {{id}}
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  methods:{
    ...mapActions({
      obtener_datos_proveedores: 'Cotizaciones/obtener_datos_proveedores'
    })
  },
  created(){
    this.proveedores = this.obtener_datos_proveedores({id: this.id})
  },
  data: ()=>({
    proveedores: []
  }),
  props: {
    id: String
  }
}
</script>